import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Modal, Card, CardContent, Stack, Button, Typography } from '@mui/material';
import { useQuery } from 'react-fetching-library';
import { checkSlotsControlAction } from '../../../services/request';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const ConfirmChangeStateModal = ({ open, handleClose, handleSubmit, state, loading }) => {
  const { order } = useSelector(state => state.orderData);
  const [payload, setPayload] = React.useState();
  const checkOrderSlotsControl = useQuery(checkSlotsControlAction(order.id));

  React.useEffect(() => {
    if (!checkOrderSlotsControl.loading && !checkOrderSlotsControl.error) {
      setPayload(checkOrderSlotsControl.payload);
    }

  }, [checkOrderSlotsControl.loading]);


  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Card sx={{ ...style }}>
        <CardContent sx={{ flexGrow: 1, width: '400px' }}>
          <Typography variant="body1" textAlign="center">
              Czy na pewno chcesz zmienić status z <span style={{ fontWeight: 'bold' }}>{order.state_name}</span> na <span style={{ fontWeight: 'bold' }}>{order.states[state]}</span> dla zamówienia <span style={{ fontWeight: 'bold' }}>{order.identifier}</span>?
          </Typography>
          {payload === false && order.states[state] == 'Potwierdzone' && <Typography color="error" variant="h6" textAlign="center">
            Uwaga!
            <br />
            Maksymalne stopnie obciążenia na zajęcia w tym zamówieniu zostały przekroczone. Czy na pewno chcesz je potwierdzić?
          </Typography>}
          <Box height={40} />
          <Stack flexDirection="row" justifyContent="space-around">
            <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>Nie</Button>
            <Button sx={{ flexGrow: 0.4 }} variant="contained" disabled={loading || payload === undefined} onClick={() => handleSubmit(order.id, { state })}>Tak</Button>
          </Stack>
        </CardContent>
      </Card>
    </Modal>);
};

export default ConfirmChangeStateModal;
